import Vue from "vue";
import Vuex from "vuex";
import auth from "./auth";
import db from "./db";
import ui from "./ui";
import shared from "./shared";
import event from "./event";
import featureRequests from "./featureRequests";

import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    db,
    ui,
    shared,
    event,
    featureRequests,
  },
  plugins: [createPersistedState()],
  strict: process.env.NODE_ENV !== "production",
});
